module.exports = __webpack_public_path__ + "assets/images/project/capacity-size/tablet.svg?v=7b2f261b";